import axios from 'axios';
import { store } from './redux/store';

// Inject le JWT sur TOUTE requête axios automatiquement
axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.user?.currentUser?.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Gestion centralisée des réponses (401 = token expiré)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalide ou expiré → déconnexion propre
      localStorage.removeItem('persist:root');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);